import { ButtonBase, Grid, Typography } from '@mui/material';
import JobMatchCard from '../subcomponents/JobMatchCard';
import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import PracticeMatchCard from '../subcomponents/PracticeMatchCard';
import PracticeJobMatchCard from '../subcomponents/PracticeJobMatchCard';
import { navy, selectedPractice, violetBlue } from '../../css/style';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


class PracticeMatchView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      matches,
      user,
      actions,
      unreadMsgCounts,
      fastpassData,
      reliefDates,
      deleteMatch,
      showSchedule,
      handlePracticeClick,
      matchToBeDeleted,
      isMatchDeleted,
      refreshStats,
      confirmConnectToMatch,
      matchPractices,
      isMobile,
    } = this.props;

    if (isMobile) {
      return this.renderMobile(matchPractices, matches, user, actions, fastpassData, showSchedule, refreshStats, reliefDates, confirmConnectToMatch, unreadMsgCounts, deleteMatch, handlePracticeClick, matchToBeDeleted, isMatchDeleted);
    }
    return this.renderDesktop(matchPractices, matches, user, actions, fastpassData, showSchedule, refreshStats, reliefDates, confirmConnectToMatch, unreadMsgCounts, deleteMatch, handlePracticeClick, matchToBeDeleted, isMatchDeleted);
  }

  getPracticeBoostRange = (practiceId, matches) => {
    const boosted = matches.filter(m => m.practice?.id === practiceId && m.jobPosting?.isBoostedByDates);
    if (!boosted.length) return null;
    const amounts = boosted.flatMap(m => [m.jobPosting?.minBoostAmount, m.jobPosting?.maxBoostAmount]).filter(Boolean);
    if (!amounts.length) return '';
    const min = Math.min(...amounts);
    const max = Math.max(...amounts);
    return min === max ? `Boosted +$${min}` : `Boosted +$${min} to +$${max}`;
  };

  sortByAvailableShifts = (items, type, matches) => {
    const today = new Date().toISOString().substring(0, 10);

    const withDates = [];
    const withoutDates = [];

    if (type === 'practice') {
      const countsByPracticeId = new Map();
      matches.forEach((match) => {
        const shifts = match?.avaiDateKeyList?.filter(d => d >= today)?.length || 0;
        if (shifts > 0) {
          const pid = match?.practice?.id;
          if (pid != null) {
            countsByPracticeId.set(pid, (countsByPracticeId.get(pid) || 0) + shifts);
          }
        }
      });

      items.forEach((practice) => {
        const count = countsByPracticeId.get(practice.id) || 0;
        (count > 0 ? withDates : withoutDates).push({ ...practice, availableShiftsCount: count });
      });
    } else {
      // type === 'match'
      items.forEach((match) => {
        const count = match?.avaiDateKeyList?.filter(d => d >= today)?.length || 0;
        (count > 0 ? withDates : withoutDates).push({ ...match, availableShiftsCount: count });
      });
    }

    return [...withDates, ...withoutDates];
  };

  renderDesktop(matchPractices, matches, user, actions, fastpassData, showSchedule, refreshStats, reliefDates, confirmConnectToMatch, unreadMsgCounts, deleteMatch, handlePracticeClick, matchToBeDeleted, isMatchDeleted) {
    let {
      handlePracticeSelected = (p) => {},
      selectedPractice,
    } = this.props;

    const processedPractices = this.sortByAvailableShifts(matchPractices, 'practice', matches);

    selectedPractice = selectedPractice || (processedPractices.length ? processedPractices[0] : null);
    if (selectedPractice && processedPractices.length && !processedPractices.filter(practice => practice.id === selectedPractice.id).length) {
      selectedPractice = processedPractices[0];
    }

    const filteredMatches = selectedPractice ? matches.filter(item => item.practice?.id === selectedPractice.id) : matches;
    const r0 = processedPractices.length && processedPractices[0].id === selectedPractice?.id;

    const processedMatches = this.sortByAvailableShifts(filteredMatches, 'match');

    return (
      <>
        <Grid item xs={6}>
          <Typography
            align="center"
            style={{
              color: navy,
              fontWeight: 800,
            }}
          >
            Practices
          </Typography>
          {processedPractices.map(practice => (
              <PracticeMatchCard
                key={practice.id}
                user={user}
                actions={actions}
                practice={practice}
                fastpassData={fastpassData}
                showSchedule={showSchedule}
                isSelected={selectedPractice?.id === practice.id}
                onClick={() => handlePracticeSelected(practice)}
                availableShiftsCount={practice.availableShiftsCount}
                boostRange={this.getPracticeBoostRange(practice.id, matches)}
              />
          ))}
        </Grid>
        <Grid item xs={6}>
          <Typography
            align="center"
            style={{
              color: navy,
              fontWeight: 800,
            }}
          >
            Shift Matches
          </Typography>
          <div style={{
            backgroundColor: violetBlue,
            position: 'sticky',
            top: 0,
            borderRadius: `${r0 ? '0' : '10px'} 10px 10px 10px`,
          }}
          >
            {processedMatches.map(match => (
              <PracticeJobMatchCard
                enableDelete
                user={user}
                refreshStats={refreshStats}
                actions={actions}
                item={match}
                reliefDates={reliefDates}
                confirmConnectToMatch={() => confirmConnectToMatch(match)}
                unreadCount={!isEmpty(unreadMsgCounts) ? unreadMsgCounts[match.id] : 0}
                deleteMatch={() => deleteMatch(match)}
                handlePracticeClick={handlePracticeClick}
                open={!(matchToBeDeleted.id === match.id && isMatchDeleted)}
                fastpassData={fastpassData}
                availableShiftsCount={match.availableShiftsCount}
              />
            ))}
          </div>
        </Grid>
      </>
    );
  }

  renderPracticeMatches(selectedPractice, matches, user, actions, fastpassData, showSchedule, refreshStats, reliefDates, confirmConnectToMatch, unreadMsgCounts, deleteMatch, handlePracticeClick, matchToBeDeleted, isMatchDeleted) {
    const filteredMatches = matches.filter(item => item.practice?.id === selectedPractice.id);
    const processedMatches = this.sortByAvailableShifts(filteredMatches, 'match');

    return (
      <Grid item xs={12}>
        <Grid container direction="row" alignContent="center">
          <Grid item xs={1}>
            <ButtonBase onClick={() => this.setState({ selectedPractice: null })}>
              <ChevronLeftIcon style={{
                fontSize: 44,
                color: navy,
              }}
              />
            </ButtonBase>
          </Grid>
          <Grid item xs={10}>
            <Typography
              color="secondary"
              style={{
                fontSize: 26,
                fontWeight: 800,
              }}
            >
              {selectedPractice.name}
            </Typography>
          </Grid>
        </Grid>
        {processedMatches.map(match => (
          <PracticeJobMatchCard
            enableDelete
            user={user}
            refreshStats={refreshStats}
            actions={actions}
            item={match}
            reliefDates={reliefDates}
            confirmConnectToMatch={() => confirmConnectToMatch(match)}
            unreadCount={!isEmpty(unreadMsgCounts) ? unreadMsgCounts[match.id] : 0}
            deleteMatch={() => deleteMatch(match)}
            handlePracticeClick={handlePracticeClick}
            open={!(matchToBeDeleted.id === match.id && isMatchDeleted)}
            fastpassData={fastpassData}
            availableShiftsCount={match.availableShiftsCount}
          />
        ))}
      </Grid>
    );
  }

  renderMobile(matchPractices, matches, user, actions, fastpassData, showSchedule, refreshStats, reliefDates, confirmConnectToMatch, unreadMsgCounts, deleteMatch, handlePracticeClick, matchToBeDeleted, isMatchDeleted) {
    const { selectedPractice } = this.props;
    if (selectedPractice) {
      return this.renderPracticeMatches(selectedPractice, matches, user, actions, fastpassData, showSchedule, refreshStats, reliefDates, confirmConnectToMatch, unreadMsgCounts, deleteMatch, handlePracticeClick, matchToBeDeleted, isMatchDeleted);
    }

    const processedPractices = this.sortByAvailableShifts(matchPractices, 'practice', matches);

    return (
      <Grid item xs={12}>
        {processedPractices.map(practice => (
          <PracticeMatchCard
            user={user}
            actions={actions}
            practice={practice}
            fastpassData={fastpassData}
            showSchedule={showSchedule}
            isMobile
            isSelected={selectedPractice?.id === practice.id}
            onClick={() => this.setState({ selectedPractice: practice })}
            availableShiftsCount={practice.availableShiftsCount}
            boostRange={this.getPracticeBoostRange(practice.id, matches)}
          />
        ))}
      </Grid>
    );
  }
}

export default PracticeMatchView;
